import { render, staticRenderFns } from "./UiAutocomplete.vue?vue&type=template&id=7ecff10c&scoped=true"
import script from "./UiAutocomplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiAutocomplete.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UiAutocomplete.vue?vue&type=style&index=0&id=7ecff10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecff10c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/ui/UiIcon.vue').default,UiSpinnerCircle: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/ui/UiSpinnerCircle.vue').default})
